export default __webpack_public_path__ + "static/media/190629_190332_IMG_E2717.af6ce0be.jpg";